/**
 * Local Storage key. Returns undefined or an object with shape:
 *      version: String,
 *      viewedThisSession: Boolean,
 *      totalViewCount: Number,
 */
export const MODAL_ID = 'collabPurchaseModal';

/**
 * Track version of storage data. This way when functionality changes, we can
 * bump version to throw away old storage data.
 */
export const CURRENT_VERSION = '1';

/**
 * Class name used to "tag" the html element used to mount the collaborative
 * purchase modal
 */
export const CONTAINER_CLASSNAME = 'collaborativePurchasingModalContainer';

/**
 * The total number of times the user should be shown the modal
 */
export const NUM_TIMES_TO_SHOW = 2;

/**
 * The total number of pages to visit in a given session to open the modal
 */
export const NUM_VISITS_TO_SHOW = 3;
